<script>
  import GbtaFileUploadDialog from './GbtaFileUploadDialog.svelte';
  import {matchBidsUsingPropCodes} from './gbta-file-upload-matchers';
  import {mainAPI} from 'root/angular-injector-provider';

  export let cancel, hide, bids = [], actionResultHandler = () => {};

  const title = `Upload Hotel RFP Questionnaire Response${bids.length > 1 ? 's' : ''}`;

  async function upload(bid, data){
    const actionReport = await mainAPI().saveDraftResponse(bid._id, data.response);
    actionResultHandler.handleActionResult(actionReport, [bid]);
  }

</script>

<GbtaFileUploadDialog
  cancel={cancel}
  hide={hide}
  matchFn={matchBidsUsingPropCodes(bids, ['SABRE_PROPCODE', 'PROPCODE'])}
  uploadFn={upload}
>
  <div slot="title">{title}</div>
  <div slot="description">
    <div>Upload hotel RFP questionnaire responses with a GBTA-compatible Excel or CSV file. The file must have GBTA question IDs as headers.</div>
    <div>Uploaded responses are saved as drafts and are not automatically submitted!</div>
    <div>Rows in the uploaded file are matched with bids based on the value in the "SABRE_PROPCODE" or "PROPCODE" column. The code in the "PROPCODE" column should be the ReadyBid property code, which is available from the GBTA or the Bid Manager export.</div>
  </div>
</GbtaFileUploadDialog>
